import React from 'react';
import PropTypes from 'prop-types';

import Markdown from '../Markdown';

const DescriptionRenderer = ({ item }) => (
  <Markdown
    className="col-xl-12 col-lg-12 mt-3"
    text={item.description}
  />
);

DescriptionRenderer.propTypes = {
  item: PropTypes.object.isRequired,
};

export default DescriptionRenderer;
